module.exports = __webpack_public_path__ + "static/media/gallery_solution.f78f4930.png";